module.exports = __webpack_public_path__ + "static/media/pixel_CarAccident.5763f16a.png";